export const BB_ABBV = "bb";
export const BB_NAME = "Banco do Brasil";
export const BB_URI = "https://bb.guerraconsorcios.com.br";
export const CAIXA_ABBV = "caixa";
export const CAIXA_NAME = "CAIXA Econômica";
export const CAIXA_URI = "https://caixa.guerraconsorcios.com.br";
export const ITAU_ABBV = "itau";
export const ITAU_NAME = "Itaú";
export const ITAU_URI = "https://itau.guerraconsorcios.com.br";
export const SANTANDER_ABBV = "santander";
export const SANTANDER_NAME = "Santander";
export const SANTANDER_URI = "https://santander.guerraconsorcios.com.br";
export const UNIFISA_ABBV = "unifisa";
export const UNIFISA_NAME = "Unifisa";
export const UNIFISA_URI = "https://unifisa.guerraconsorcios.com.br";
export const YAMAHA_ABBV = "yamaha";
export const YAMAHA_NAME = "Yamaha";
export const YAMAHA_URI = "https://yamaha.guerraconsorcios.com.br";
export const CNVW_ABBV = "volkswagen";
export const CNVW_NAME = "Volkswagen";
export const CNVW_URI = "https://volkswagem.guerraconsorcios.com.br";
export const SERVOPA_ABBV = "servopa";
export const SERVOPA_NAME = "Servopa";
export const SERVOPA_URI = "https://servopa.guerraconsorcios.com.br";